import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { CountryTemplate } from '../../models/stack9/CountryTemplate';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type CountryTemplateDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partial<CountryTemplate>;
};

export const CountryTemplateDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: CountryTemplateDrawerProps) => {
  const formFields = [
    { field: 'country' },
    { field: 'include_all_base_requirements' },
  ];

  return (
    <EntityDrawer
      title="country template"
      open={open}
      id={id}
      formFields={formFields}
      initialValues={initialValues}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetCountryTemplateDetails}
      entityName={entityNames.COUNTRY_TEMPLATE}
      editRoute={AppRoutes.CountryTemplateDetail}
      relativePath={AppRoutes.CountryTemplateDetail}
    />
  );
};
